const UNCATEGORIZED_LABEL = 'Non catégorisé';

// Palette catégorielle validée (CVD-safe), déjà utilisée par WaterUsageChart.js pour les
// donuts de consommation par unité fonctionnelle — reprise ici pour que la même unité
// porte toujours la même couleur d'un bout à l'autre de l'app.
const TAG_PALETTE = [
  '#2a78d6', '#1baf7a', '#eda100', '#008300', '#4a3aa7', '#e34948', '#e87ba4', '#eb6834',
];

const withAlpha = (hex, alpha) => `${hex}${Math.round(alpha * 255).toString(16).padStart(2, '0')}`;

// Assombrit une couleur pour l'utiliser en texte lisible sur son propre fond clair
// (certaines teintes de la palette, ex. le jaune, sont trop claires telles quelles).
const darken = (hex, amount) => {
  const num = parseInt(hex.slice(1), 16);
  const channel = (shift) => Math.round(((num >> shift) & 255) * (1 - amount)).toString(16).padStart(2, '0');
  return `#${channel(16)}${channel(8)}${channel(0)}`;
};

export function getFunctionalUnitTagStyle(value, functionalUnits) {
  const index = functionalUnits.findIndex((u) => u.id === value);
  if (index === -1) return undefined;
  const baseColor = TAG_PALETTE[index % TAG_PALETTE.length];
  return {
    '--fu-tag-bg': withAlpha(baseColor, 0.14),
    '--fu-tag-border': withAlpha(baseColor, 0.34),
    '--fu-tag-text': darken(baseColor, 0.25),
  };
}

/**
 * Petite étiquette colorée représentant une unité fonctionnelle, éditable en
 * cliquant dessus (c'est un <select> natif stylé en tag). `variant` choisit le
 * gabarit de taille : 'section' | 'room' | 'usage'.
 */
export default function FunctionalUnitTag({ value, functionalUnits, onChange, variant = 'room' }) {
  const current = functionalUnits.find((u) => u.id === value) || null;
  const tagStyle = getFunctionalUnitTagStyle(value, functionalUnits);

  return (
    <select
      className={[
        'reorg-fu-tag',
        `reorg-fu-tag--${variant}`,
        !current ? 'reorg-fu-tag--empty' : '',
      ].join(' ')}
      style={tagStyle}
      value={value || ''}
      onClick={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      onChange={(e) => onChange(e.target.value)}
      title="Unité fonctionnelle"
    >
      <option value="">{UNCATEGORIZED_LABEL}</option>
      {functionalUnits.map((u) => (
        <option key={u.id} value={u.id}>{u.name || 'Sans nom'}</option>
      ))}
    </select>
  );
}
